import {
  Box,
  Flex,
} from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { FloatingChatDrawer } from './FloatingChatDrawer'
import { ChatActionBridgeProvider } from '@/features/chat/agent/ChatActionBridge'
import { useChatActionBridge } from '@/features/chat/agent/chatActionBridgeContext'

/** Width of the floating chat drawer on md+ (SideDrawer's default). */
const CHAT_DRAWER_WIDTH = '420px'

function LayoutBody() {
  const bridge = useChatActionBridge()
  // While the Chat drives a page (the wizard, the Requirement Doctor), dock it beside the page instead of covering it.
  const docked = !!bridge?.chatOpen && (!!bridge?.wizardAttached || !!bridge?.reqGuardAttached)

  return (
    <Flex h="100dvh" overflow="hidden">
      <Sidebar />
      <Box
        flex="1"
        minH="0"
        display="flex"
        flexDirection="column"
        overflow="auto"
        bg="surface.dark"
        p={6}
        mr={{ base: 0, md: docked ? CHAT_DRAWER_WIDTH : 0 }}
        transition="margin-right 0.25s ease"
      >
        <Outlet />
      </Box>
      <FloatingChatDrawer />
    </Flex>
  )
}

export function RootLayout() {
  return (
    <ChatActionBridgeProvider>
      <LayoutBody />
    </ChatActionBridgeProvider>
  )
}
